module.exports = "/assets/data/f09e5b053a92025ef114f918f225ba25-CB3.data.json";